<template>
  <div>
    <wrapper-preview-category customClass="section-preview_lk">
      <h2 class="font-weight-bold font-size-large main-color mb-3">
        Контактная информация ответственного исполнителя
      </h2>
      <contact-person
        :canBeDeleted="false"
        :contact="getContact"
        :isSingle="true"
        :loadingContacts="loading"
        :savingData="contact.loading"
        @change-contact="changeContact($event, 'OTV')" />
    </wrapper-preview-category>
    <wrapper-preview-category customClass="section-preview_lk">
      <h2 class="font-weight-bold font-size-large main-color mb-3">
        Контактная информация руководителя организации
      </h2>
      <contact-person
        :canBeDeleted="false"
        :contact="getContactMain"
        :isSingle="true"
        :loadingContacts="loading"
        :savingData="contactMain.loading"
        @change-contact="changeContactMain($event, 'MAIN')" />
    </wrapper-preview-category>
    <Alert alert-type="success mt-3">
      <template #icon>
        <v-icon color="#D4990A" size="40">mdi-success</v-icon>
      </template>
      <template #default>
        <div class="d-flex flex-row justify-space-between">
          <p class="d-flex align-center">
            {{ isBlocked.FULL ? 'Ввод данных заблокирован' : 'Форма доступна для заполнения:' }}
          </p>
          <v-dialog>
            <template #activator="{ on, attrs }">
              <v-btn class="success__v-btn" v-on="on" v-bind="attrs">Блокировки</v-btn>
            </template>
            <template>
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                  <v-row v-for="row in blocks" :key="row.type">
                    <v-col cols="9">
                      {{ row.text }}
                      <ul>
                        <li v-for="(item, i) in canBlock[row.type].messages" :key="i">
                          {{ item }}
                        </li>
                      </ul>
                    </v-col>
                    <v-col>
                      <v-btn
                        :disabled="
                          (canBlock[row.type] && !canBlock[row.type].value) || isBlocked[row.type]
                        "
                        :loading="loadingBlockEnterData"
                        @click="clickBlockEnterData([row.type])"
                        class="success__v-btn"
                        color="#29A128">
                        <span style="color: #fff">{{
                          isBlocked[row.type] ? 'Заблокировано' : 'Заблокировать ввод'
                        }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!--                  <v-row>
                    <v-col cols="9"> Блокировка все бюджетники, аспирантура:
                      <ul>
                        <li v-for="(item, i ) in canBlock.POSTGRADUATE.messages" :key="i">{{ item }}</li>
                      </ul>
                    </v-col>
                    <v-col>
                      <v-btn
                          :disabled="(canBlock.POSTGRADUATE && !canBlock.POSTGRADUATE.value) || isBlocked.POSTGRADUATE"
                          :loading="loadingBlockEnterData"
                          @click="clickBlockEnterData('POSTGRADUATE')"
                          class="success__v-btn"
                          color="#29A128"
                      >
            <span style="color:#fff;">{{
                isBlocked.POSTGRADUATE ? 'Заблокировано' : 'Заблокировать ввод'
              }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="9"> Блокировка все бюджетники, ординатура:
                      <ul>
                        <li v-for="(item, i ) in canBlock.INTERNSHIP.messages" :key="i">{{ item }}</li>
                      </ul>
                    </v-col>
                    <v-col>
                      <v-btn
                          :disabled="(canBlock.INTERNSHIP && !canBlock.INTERNSHIP.value) || isBlocked.INTERNSHIP"
                          :loading="loadingBlockEnterData"
                          @click="clickBlockEnterData('INTERNSHIP')"
                          class="success__v-btn"
                          color="#29A128"
                      >
            <span style="color:#fff;">{{
                isBlocked.INTERNSHIP ? 'Заблокировано' : 'Заблокировать ввод'
              }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="9"> Блокировка платники, все уровни:
                      <ul>
                        <li v-for="(item, i ) in canBlockPaidMessages" :key="i">{{ item }}</li>
                      </ul>
                    </v-col>
                    <v-col>
                      <v-btn
                          :disabled="(!canBlockPaid) || isBlockedPaid"
                          :loading="loadingBlockEnterData"
                          @click="clickBlockEnterData('PAID')"
                          class="success__v-btn"
                          color="#29A128"
                      >
            <span style="color:#fff;">{{
                isBlockedPaid ? 'Заблокировано' : 'Заблокировать ввод'
              }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>-->
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
        </div>
        <div
          v-if="isBlocked.BSMA || isBlocked.POSTGRADUATE || isBlocked.INTERNSHIP || isBlockedPaid"
          class="d-flex flex-row justify-end mb-3">
          <v-btn @click="openScansDialog()" class="white__v-btn mt-2">Загрузка сканов</v-btn>
        </div>
      </template>
    </Alert>
    <scans-dialog
        :let-blocked="isBlocked"
      :show="scanDialogShow"
      @close-scan-dialog="scanDialogShow = false"
      ref="scan-dialog"></scans-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  // import request from "@/services/request";
  import ContactPerson from '@/components/forms/contacts/ContactPerson';
  import WrapperPreviewCategory from '@/components/cards/WrapperPreviewCategory';
  import ScansDialog from '@/components/dialog/scansDialog';
  import CardPrinDocumentBtn from '@/components/UI/cardPrinDocumentBtn';
  import Alert from '@/components/UI/Alert';
  import { getContacts, updateContact } from '@/API/user';

  export default {
    name: 'OrgContact',
    // eslint-disable-next-line vue/no-unused-components
    components: { Alert, CardPrinDocumentBtn, ScansDialog, WrapperPreviewCategory, ContactPerson },
    data: () => ({
      contact: {
        loading: false,
        error: null,
        data: {
          fio: '',
          email: '',
          position: '',
          workPhoneNumber: '',
          mobilePhoneNumber: '',
          type: 'OTV',
        },
      },
      contactMain: {
        loading: false,
        error: null,
        data: {
          fio: '',
          email: '',
          position: '',
          workPhoneNumber: '',
          mobilePhoneNumber: '',
          type: 'MAIN',
        },
      },
      blocks: [
        { text: 'Блокировка все бюджетники, БСМ и ассистентура:', type: 'BSMA' },
        { text: 'Блокировка все бюджетники, аспирантура:', type: 'POSTGRADUATE' },
        { text: 'Блокировка все бюджетники, ординатура:', type: 'INTERNSHIP' },
        { text: 'Блокировка все платники, БСМ:', type: 'PAID_BSM' },
        { text: 'Блокировка все платники, ассистентура:', type: 'PAID_ASSIST' },
        { text: 'Блокировка все платники, аспирантура:', type: 'PAID_POSTGRADUATE' },
        { text: 'Блокировка все платники, ординатура:', type: 'PAID_INTERNSHIP' },
      ],
      loading: false,
      showMenu: false,
      scanDialogShow: false,
      loadingBlockEnterData: false,
      selectedYear: '2024',
    }),
    computed: {
      ...mapGetters('keycloak', {
        getUserRoles: 'getUserRoles',
        getUserAccessToken: 'getUserAccessToken',
        getUser: 'getUser',
        getFakeUser: 'getFakeUser',
      }),
      ...mapGetters('checkFilled', {
        getBlockStatus: 'getBlockStatus',
        getBlockStatusEdit: 'getBlockStatusEdit',
      }),
      ...mapGetters({ getSelectedYear: 'selectedYear' }),
      getYear() {
        if (this.getSelectedYear) return this.getSelectedYear;
        return this.selectedYear;
      },
      getOrgId() {
        if (this.getFakeUser) return this.getFakeUser.id;
        return this.getUser.orgID;
      },
      isAdmin() {
        return !!this.getUserRoles.find((el) => el === 'ADMIN_ROLE');
      },
      isBlocked() {
        if (this.isAdmin) return true;
        return this.getBlockStatus;
      },
      // messageBlock() {
      //   return this.getCanBlockInfo?.message ?? '';
      // },
      canBlock() {
        return this.getBlockStatusEdit;
      },
      canBlockPaid() {
        return (
          this.getBlockStatusEdit.PAID_BSM.value &&
          this.getBlockStatusEdit.PAID_ASSIST.value &&
          this.getBlockStatusEdit.PAID_INTERNSHIP.value &&
          this.getBlockStatusEdit.PAID_POSTGRADUATE.value
        );
      },
      isBlockedPaid() {
        return (
          this.getBlockStatus.PAID_BSM ||
          this.getBlockStatus.PAID_ASSIST ||
          this.getBlockStatus.PAID_INTERNSHIP ||
          this.getBlockStatus.PAID_POSTGRADUATE
        );
      },
      canBlockPaidMessages() {
        return [
          ...this.getBlockStatusEdit.PAID_BSM.messages,
          ...this.getBlockStatusEdit.PAID_ASSIST.messages,
          ...this.getBlockStatusEdit.PAID_INTERNSHIP.messages,
          ...this.getBlockStatusEdit.PAID_POSTGRADUATE.messages,
        ];
      },
      getContact() {
        return this.contact.data;
      },
      getContactMain() {
        return this.contactMain.data;
      },
      token() {
        return this.getUserAccessToken;
      },
      orgId() {
        if (this.isAdmin) return this.getFakeUser?.id;
        return this.getUser?.orgID;
      },
    },
    watch: {
      getYear() {
        this.getContactData();
      },
    },
    created() {
      this.getContactData();
    },
    methods: {
      ...mapActions('notification', { setNotification: 'setNotification' }),
      ...mapActions('checkFilled', {
        blockOneType: 'blockOneType',
      }),
      openScansDialog() {
        this.scanDialogShow = true;
      },
      async clickBlockEnterData(type = 'BSMA') {
        this.loadingBlockEnterData = true;
        try {
          if (type === 'PAID') {
            ['PAID_INTERNSHIP', 'PAID_POSTGRADUATE', 'PAID_ASSIST', 'PAID_BSM'].map(async (el) =>
              !this.isBlocked[el] ? await this.blockOneType({ type: el, value: true }) : () => {},
            );
            // await Promise.allSettled(arr)
          } else await this.blockOneType({ type: type, value: true });
        } catch (e) {
          console.error(e);
        }
        this.loadingBlockEnterData = false;
      },
      async changeContact(event, type = 'OTV') {
        this.contact.loading = true;
        this.contact.error = null;
        try {
          const res = await updateContact({ ...event, type: type }, this.getOrgId, this.getYear);
          if (res) {
            this.contact.data = res;
          }
          this.contact.loading = false;
        } catch (e) {
          this.contact.error = e;
          this.contact.loading = false;
        }
      },
      async changeContactMain(event, type = 'OTV') {
        this.contactMain.loading = true;
        this.contactMain.error = null;
        try {
          const res = await updateContact({ ...event, type: type }, this.getOrgId, this.getYear);
          if (res) {
            this.contactMain.data = res;
          }
          this.contactMain.loading = false;
        } catch (e) {
          this.contactMain.error = e;
          this.contactMain.loading = false;
        }
      },
      async getContactData() {
        this.loading = true;
        this.contact.error = null;
        try {
          const res = await getContacts(this.getOrgId, this.getYear);
          if (res && res.length > 0) {
            this.contact.data = res.find((el) => el.type === 'OTV');
            this.contactMain.data = res.find((el) => el.type === 'MAIN');
          } else {
            this.contact.error = res;
          }
          this.loading = false;
        } catch (e) {
          this.contact.error = e;
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped></style>
